(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["subscription-options"] && !Shopify.designMode) return;
  try {
    class SubscriptionOptions extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.#onChange);
      this.#section = this.closest('.shopify-section, dialog');
      this.#section?.addEventListener('variant:update', this.#onVariantUpdate);
      this.#sync();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
      this.#section?.removeEventListener('variant:update', this.#onVariantUpdate);
    }

    #section = null;

    #onChange = (event) => {
      if (event.target instanceof HTMLInputElement) this.#sync();
    };

    #onVariantUpdate = (event) => {
      const selector = `subscription-options[data-block-id="${this.dataset.blockId}"]`;
      const incoming = event.detail?.data?.html?.querySelector(selector);
      if (!incoming) return;

      const isSubscribe = this.#mode === 'subscribe';
      const frequencyIndex = this.#frequencies.indexOf(this.#selectedFrequency);

      this.innerHTML = incoming.innerHTML;

      const modes = this.querySelectorAll('[data-mode]');
      modes.forEach((input) => {
        input.checked = (input.dataset.mode === 'subscribe') === isSubscribe;
      });

      const frequencies = this.#frequencies;
      const restored = frequencies[frequencyIndex] ?? frequencies[0];
      if (restored) restored.checked = true;

      this.#sync();
    };

    get #frequencies() {
      return Array.from(this.querySelectorAll('[name^="subscription-frequency-"]'));
    }

    get #selectedFrequency() {
      return this.#frequencies.find((input) => input.checked) ?? null;
    }

    get #mode() {
      const checked = this.querySelector('[data-mode]:checked');
      return checked?.dataset.mode ?? 'subscribe';
    }

    #sync() {
      const field = this.querySelector('[data-selling-plan-field]');
      if (!field) return;

      const frequency = this.#selectedFrequency;
      const subscribing = this.#mode === 'subscribe' && frequency != null;

      field.disabled = !subscribing;
      field.value = subscribing ? frequency.value : '';

      this.#updateCta(subscribing);
      this.dispatchEvent(
        new CustomEvent('subscription-options:change', {
          bubbles: true,
          detail: { mode: subscribing ? 'subscribe' : 'onetime', sellingPlanId: field.value },
        })
      );

      if (!subscribing) return;

      this.#write('[data-display-price]', frequency.dataset.price);
      this.#write('[data-display-compare]', frequency.dataset.compare);
      this.#write('[data-display-pill]', frequency.dataset.pill);
      this.#write('[data-display-unit]', frequency.dataset.unit);
      this.#write('[data-display-note]', frequency.dataset.note);

      const unitLine = this.querySelector('[data-unit-line]');
      if (unitLine) unitLine.hidden = !frequency.dataset.unit;
    }

    #updateCta(subscribing) {
      const label = subscribing ? this.dataset.ctaSubscribe : this.dataset.ctaOnetime;
      if (!label) return;

      const form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
      const button = form?.querySelector('.add-to-cart-button');
      if (!button) return;

      const textNode = Array.from(button.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
      );
      if (textNode) textNode.textContent = label;
    }

    #write(selector, value) {
      if (value == null) return;
      const target = this.querySelector(selector);
      if (target) target.textContent = value;
    }
  }

  if (!customElements.get('subscription-options')) {
    customElements.define('subscription-options', SubscriptionOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trust-row"] && !Shopify.designMode) return;
  try {
    class TrustRow extends HTMLElement {
    connectedCallback() {
      this.#onetime = this.querySelector('[data-trust-set="onetime"]');
      if (!this.#onetime) return;

      this.#subscribe = this.querySelector('[data-trust-set="subscribe"]');
      document.addEventListener('subscription-options:change', this.#onChange);

      const selected = document.querySelector('subscription-options [data-mode]:checked');
      this.#apply(selected?.dataset.mode !== 'onetime');
    }

    disconnectedCallback() {
      document.removeEventListener('subscription-options:change', this.#onChange);
    }

    #subscribe = null;
    #onetime = null;

    #onChange = (event) => {
      this.#apply(event.detail?.mode !== 'onetime');
    };

    #apply(subscribing) {
      if (this.#subscribe) this.#subscribe.hidden = !subscribing;
      if (this.#onetime) this.#onetime.hidden = subscribing;
    }
  }

  if (!customElements.get('trust-row')) {
    customElements.define('trust-row', TrustRow);
  }
  } catch(e) { console.error(e); }
})();

})();
